import React from 'react';
import './App.css';
import { Route, Routes, BrowserRouter } from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./components/Home";
import AboutUs from "./components/AboutUs";
import ContactUs from "./components/ContactUs";
import Registration from "./components/Registration";
import RegistrationNew from "./components/RegistrationNew";
import PrintForm from "./components/PrintForm";
import Courses from './components/Courses';
import RegistrationSuccess from './components/RegistrationSuccess';

import AdminLogin from "./components/admin/AdminLogin";
import AdminLayout from "./components/admin/AdminLayout";
import Dashboard from "./components/admin/Dashboard";
import FormList from "./components/admin/FormList";
import ViewForm from "./components/admin/ViewForm";
import AdminPrintView from "./components/admin/AdminPrintView";

import { useLocation } from "react-router-dom";

function AppLayout() {
  const location = useLocation();

  const hideHeader = location.pathname.startsWith('/admin');
  const hideFooter =
    location.pathname === '/PrintForm' ||
    location.pathname.startsWith('/admin');

  return (
    <>
      {!hideHeader && <Header />}

      <Routes>
        {/* PUBLIC ROUTES */}
        <Route path="/" element={<Home />} />
        <Route path="/AboutUs" element={<AboutUs />} />
        <Route path="/ContactUs" element={<ContactUs />} />
        <Route path="/Registration" element={<Registration />} />
        <Route path="/RegistrationNew" element={<RegistrationNew />} />
        <Route path="/PrintForm" element={<PrintForm />} />
        <Route path="/Courses" element={<Courses />} />
        <Route path="/RegistrationSuccess" element={<RegistrationSuccess />} />

        {/* ADMIN ROUTES */}
        <Route path="/admin/login" element={<AdminLogin />} />

        <Route path="/admin" element={<AdminLayout />}>
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="forms" element={<FormList />} />
          <Route path="forms/:formId" element={<ViewForm />} />

        </Route>
          <Route path="/admin/print/:formId" element={<AdminPrintView />} />
      </Routes>

      {!hideFooter && <Footer />}
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppLayout />
    </BrowserRouter>
  );
}

export default App;
